import { Trans } from '@lingui/macro';
import _ from 'lodash';
import { MenuItem } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import FormSection from '../../form/FormSection';
import NgpSelect from '../../form/NgpSelect';
import {
    WEB_PROXY_AUTO_PROXY_OPTION,
    WEB_PROXY_AUTO_URL,
    WEB_PROXY_MANUAL_PORT,
    WEB_PROXY_MANUAL_PROXY_OPTION,
    WEB_PROXY_MANUAL_SERVER_ADDRESS,
    WEB_PROXY_OPTIONS,
    WEB_PROXY_PASSWORD,
    WEB_PROXY_SELECTION_FIELD,
    WEB_PROXY_USERNAME,
} from './AgentSettingsConstants';
import NgpTextField from '../../form/NgpTextField';
import { AUTO_COMPLETE_DEFAULT } from '../../../utilities/FormUtilities';
import NgpNumberField from '../../form/NgpNumberField';
import NgpPasswordField from '../../form/NgpPasswordField';

export default function WebProxyConfiguration() {
    const { watch } = useFormContext();
    const webProxySelection = watch(WEB_PROXY_SELECTION_FIELD);

    return (
        <FormSection
            title={<Trans>Default Web Proxy Configuration</Trans>}
            subText={
                <Trans>
                    Configure the default proxy which will be used by all nPoints that have “Web Proxy Configuration”
                    enabled in nPoints. The default can be overridden for each Web Proxy enabled nPoint in nPoints.
                </Trans>
            }
        >
            <NgpSelect fieldName={WEB_PROXY_SELECTION_FIELD} required>
                {_.map(WEB_PROXY_OPTIONS, (value, key) => (
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                ))}
            </NgpSelect>

            {webProxySelection === WEB_PROXY_MANUAL_PROXY_OPTION && (
                <>
                    <NgpTextField
                        fieldName={WEB_PROXY_MANUAL_SERVER_ADDRESS}
                        label={<Trans>Proxy Server Address</Trans>}
                        required
                        inputProps={{
                            size: 65,
                            maxLength: 2083,
                            autoComplete: AUTO_COMPLETE_DEFAULT,
                        }}
                    />

                    <NgpNumberField
                        fieldName={WEB_PROXY_MANUAL_PORT}
                        label={<Trans>Port</Trans>}
                        min="1"
                        max="65535"
                        inputProps={{
                            size: 5,
                            maxLength: 5,
                        }}
                    />

                    <NgpTextField
                        fieldName={WEB_PROXY_USERNAME}
                        label={<Trans>Username</Trans>}
                        inputProps={{
                            size: 65,
                            maxLength: 2083,
                            autoComplete: AUTO_COMPLETE_DEFAULT,
                        }}
                    />

                    <NgpPasswordField
                        fieldName={WEB_PROXY_PASSWORD}
                        label={<Trans>Password</Trans>}
                        inputProps={{ size: 65, maxLength: 2083 }}
                        togglePasswordVisibility
                    />
                </>
            )}

            {webProxySelection === WEB_PROXY_AUTO_PROXY_OPTION && (
                <>
                    <NgpTextField
                        fieldName={WEB_PROXY_AUTO_URL}
                        label={<Trans>Proxy Auto-Config URL</Trans>}
                        required
                        inputProps={{
                            size: 65,
                            maxLength: 2083,
                            autoComplete: AUTO_COMPLETE_DEFAULT,
                        }}
                    />

                    <NgpTextField
                        fieldName={WEB_PROXY_USERNAME}
                        label={<Trans>Username</Trans>}
                        inputProps={{
                            size: 65,
                            maxLength: 2083,
                            autoComplete: AUTO_COMPLETE_DEFAULT,
                        }}
                    />

                    <NgpPasswordField
                        fieldName={WEB_PROXY_PASSWORD}
                        label={<Trans>Password</Trans>}
                        inputProps={{ size: 65, maxLength: 2083 }}
                        togglePasswordVisibility
                    />
                </>
            )}
        </FormSection>
    );
}
